import { render, staticRenderFns } from "./newOffer.vue?vue&type=template&id=7a2edd48&scoped=true&"
import script from "./newOffer.vue?vue&type=script&lang=js&"
export * from "./newOffer.vue?vue&type=script&lang=js&"
import style0 from "./newOffer.vue?vue&type=style&index=0&id=7a2edd48&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2edd48",
  null
  
)

export default component.exports